<template>
  <div class="toggles">
    <Toggle class="toggle">
      <template v-slot:on>
        <img src="../../../images/states/morning/On.png" alt="">
      </template>
      <template v-slot:off>
        <img src="../../../images/states/morning/Off.png" alt="">
      </template>
    </Toggle>
    <Toggle>
      <template v-slot:on>
        <img src="../../../images/states/day/On.png" alt="">
      </template>
      <template v-slot:off>
        <img src="../../../images/states/day/Off.png" alt="">
      </template>
    </Toggle>
    <Toggle>
      <template v-slot:on>
        <img src="../../../images/states/night/On.png" alt="">
      </template>
      <template v-slot:off>
        <img src="../../../images/states/night/Off.png" alt="">
      </template>
    </Toggle>
  </div>
</template>

<script>
  import Toggle from '../../components/toggle/Toggle'

  export default {
    name: 'OnlineToggles',
    components: { Toggle }
  }
</script>

<style scoped>

  img {
    width: 100%;
  }
</style>
